// Tujuan: Reducer untuk state PO Analytics — data analytics per produk + rekomendasi global
// Caller: rootReducer (combineReducers)
// Dependencies: store/actionTypes/po
// Main Functions: poReducer
// Side Effects: none

import * as Type from "store/actionTypes/po";

const initialState = {
  isLoading: false,
  isError: false,
  message: [],
  data: null,
  recommendations: [],
  isLoadingRec: false,
  recError: null,
};

const poReducer = (state = initialState, action) => {
  switch (action.type) {
    case Type.PO_REQUEST:
      return { ...state, isLoading: true, isError: false };
    case Type.GET_PO_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case Type.GET_PO_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        message: action.payload,
      };
    case Type.PO_RECOMMENDATIONS_REQUEST:
      return { ...state, isLoadingRec: true, recError: null };
    case Type.PO_RECOMMENDATIONS_SUCCESS:
      return { ...state, isLoadingRec: false, recommendations: action.payload };
    case Type.PO_RECOMMENDATIONS_ERROR:
      return {
        ...state,
        isLoadingRec: false,
        recError: action.payload,
      };
    case Type.PO_RESET:
      return { ...initialState, recommendations: state.recommendations, isLoadingRec: false, recError: null };
    default:
      return state;
  }
};

export default poReducer;
